import { Grid, GridSize } from "@material-ui/core";
import React from "react";

import { isEmptyValue } from "../../utils";

interface SectionCardFieldGroupProps {
  columns?: number;
  children: React.ReactNode;
  className?: string;
  dataTestId?: string;
}

interface ChildWithFieldProps {
  span?: number;
  value?: React.ReactNode;
}

export default function SectionCardFieldGroup({
  columns = 4,
  children,
  className = "",
  dataTestId,
}: SectionCardFieldGroupProps) {
  const defaultSpan = Math.max(1, Math.floor(12 / columns));

  return (
    <Grid container spacing={3} className={className} data-testid={dataTestId}>
      {React.Children.map(children, (child) => {
        if (!React.isValidElement(child)) return null;
        const childProps = child.props as ChildWithFieldProps;
        if ("value" in childProps && isEmptyValue(childProps.value)) return null;
        const span = (childProps.span ?? defaultSpan) as GridSize;
        return (
          <Grid item xs={span}>
            {child}
          </Grid>
        );
      })}
    </Grid>
  );
}
